import { ThemeProvider } from '@mui/material'
import React from 'react'
import { theme } from './components/ui/Theme'
import Container from './main/Container'
import './i18n'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Container />
    </ThemeProvider>
  )
}

export default App
